import { z } from "@/zod";
import { t } from "i18next";
import { cfg } from "./cfg";

export const QUESTION_TYPE_INPUT = "input";
export const QUESTION_TYPE_TEXTAREA = "textarea";
export const QUESTION_TYPE_RADIO = "radio";
export const QUESTION_TYPE_CHECKBOX = "checkbox";
export const QUESTION_TYPE_INFO = "info";
export const QUESTION_TYPE_FILE = "file";
export const QUESTION_TYPE_SELECT = "select";
export const QUESTION_TYPE_DATE_HOUR = "datehour";
export const QUESTION_TYPE_PICTURES = "pictures";

export const QUESTION_TYPE = [
  QUESTION_TYPE_INPUT,
  QUESTION_TYPE_TEXTAREA,
  QUESTION_TYPE_RADIO,
  QUESTION_TYPE_CHECKBOX,
  QUESTION_TYPE_INFO,
  QUESTION_TYPE_FILE,
  QUESTION_TYPE_SELECT,
  QUESTION_TYPE_DATE_HOUR,
  QUESTION_TYPE_PICTURES,
] as const;

export const questionType = z.enum(QUESTION_TYPE);

export default z
  .object({
    question: z.string().min(5).max(1000),
    type: questionType,
    cfg: cfg
      .partial()
      .refine(
        // minLength should be less or equal to maxLength
        (cfg) => {
          if (cfg?.minLength !== undefined && cfg?.maxLength !== undefined) {
            return cfg.minLength <= cfg.maxLength;
          }
          return true;
        },
        {
          message: t("surveyEditor.errors.minLengthLessThanMaxLength"),
          path: ["minLength"],
        },
      )
      .refine(
        // minChecked should be less or equal to maxChecked
        (cfg) => {
          if (cfg?.minChecked !== undefined && cfg?.maxChecked !== undefined) {
            return cfg.minChecked <= cfg.maxChecked;
          }
          return true;
        },
        {
          message: t("surveyEditor.errors.minCheckedLessThanMaxChecked"),
          path: ["minChecked"],
        },
      )
      .refine(
        // minQuantity should be less or equal to maxQuantity
        (cfg) => {
          if (
            cfg?.minQuantity !== undefined &&
            cfg?.maxQuantity !== undefined
          ) {
            return cfg.minQuantity <= cfg.maxQuantity;
          }
          return true;
        },
        {
          message: t("surveyEditor.errors.minQuantityLessThanMaxQuantity"),
          path: ["minQuantity"],
        },
      ),
    hidden: z.boolean(),
    id: z.string().uuid(),
    dependentOnQuestion: z.string().uuid().optional(),
    dependentOnValue: z.array(z.string()).optional(),
  })
  .required({
    question: true,
    type: true,
    cfg: true,
    hidden: true,
    id: true,
  });
